import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import moment from 'moment';

export function Content({ themes, customers, employees }) {
  const [load, setLoad] = useState(false);

  let contentUi = <div className='loader-block' />;
  if (load) {
    contentUi = (
      <React.Fragment>
        <section className='breadcrumb'>
          <h1>Dashboard</h1>
          <ul>
            <li>
              <Link to='/home'>Pages</Link>
            </li>
            <li className='divider la la-arrow-right'></li>
            <li>Home</li>
          </ul>
          <hr className='my-3' />
          <div className='bg-gray-400 rounded overflow-hidden shadow-md rounded-lg'>
            <div className='px-6 py-4'>
              <div className=''>
                <h4 className='text-white'> Amount Data Summary</h4>
              </div>
            </div>
          </div>
          <div className='sm:grid-cols-4 grid sm:gap-7 gap-3 mt-6'>
            <div className='bg-white overflow-hidden shadow-md rounded-lg px-4 py-4'>
              <div className='px-4 bg-white flex-col justify-center items-center rounded'>
                <div className='flex justify-center'>
                  <span className='la la-user-tie text-center text-9xl text-blue-300'></span>
                </div>
                <div className='flex justify-center'>
                  <span className='text-center text-base'>
                    {employees.length} Employees
                  </span>
                </div>
              </div>
            </div>
            <div className='bg-white overflow-hidden shadow-md rounded-lg px-4 py-4'>
              <div className='px-4 bg-white flex-col justify-center items-center rounded'>
                <div className='flex justify-center'>
                  <span className='la la-palette text-center text-9xl text-red-300'></span>
                </div>
                <div className='flex justify-center'>
                  <span className='text-center text-base'>
                    {themes.length} Themes
                  </span>
                </div>
              </div>
            </div>
            <div className='bg-white overflow-hidden shadow-md rounded-lg px-4 py-4'>
              <div className='px-4 bg-white flex-col justify-center items-center rounded'>
                <div className='flex justify-center'>
                  <span className='la la-users text-center text-9xl text-yellow-300'></span>
                </div>
                <div className='flex justify-center'>
                  <span className='text-center text-base'>
                    {customers.length} Customers
                  </span>
                </div>
              </div>
            </div>
            <div className='bg-white overflow-hidden shadow-md rounded-lg px-4 py-4'>
              <div className='px-4 bg-white flex-col justify-center items-center rounded'>
                <div className='flex justify-center'>
                  <span className='la la-table text-center text-9xl text-green-300'></span>
                </div>
                <div className='flex justify-center'>
                  <span className='text-center text-base'>
                    {customers.length} Templates
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div className='sm:grid-cols-2 grid grid-flow-row grid-rows-2 sm:gap-7 gap-5 mt-10'>
            <div>
              <div className='bg-gray-400 rounded overflow-hidden shadow-md rounded-lg '>
                <div className='px-6 py-4'>
                  <h4 className='text-white'> Theme Data Summary</h4>
                </div>
              </div>
              <div className='bg-white overflow-auto shadow-md rounded-lg px-4 py-4'>
                <div className='px-4 bg-white flex-col justify-center items-center rounded h-72'>
                  <div className='border rounded-lg bg-gray-200'>
                    <div className='px-6 py-4'>
                      <div className='grid lg:grid-cols-3 '>
                        <div className='px-4 rounded'>
                          <p className='text-medium font-bold'>Theme Name</p>
                        </div>

                        <div className='px-4 rounded'>
                          <p className='text-medium font-bold'>Type Theme</p>
                        </div>

                        <div className='px-4 rounded'>
                          <p className='text-medium font-bold'>Description</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* {load ? '': null} */}
                  {load
                    ? themes.map((theme, i) => {
                        return (
                          <>
                            <div className='border overflow-hidden rounded-lg '>
                              <div className='px-6 py-4'>
                                <div className='grid lg:grid-cols-3'>
                                  <div className='px-4  bg-white flex items-center rounded'>
                                    <Link
                                      to={`/theme-management/detail/${theme.id}`}
                                    >
                                      <p className='font-bold text-left '>
                                        {theme.name}
                                      </p>
                                    </Link>
                                  </div>
                                  <div className='px-4  bg-white flex items-center rounded'>
                                    <p className='font-bold'>{theme.type}</p>
                                  </div>
                                  <div className='px-4 bg-white flex items-center rounded'>
                                    <p className='text-xs'>
                                      {theme.description}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </>
                        );
                      })
                    : null}
                </div>
              </div>
            </div>
            <div>
              <div className='bg-gray-400 rounded overflow-hidden shadow-md rounded-lg '>
                <div className='px-6 py-4'>
                  <h4 className='text-white'> Customer Data Summary</h4>
                </div>
              </div>
              <div className='bg-white overflow-auto shadow-md rounded-lg px-4 py-4'>
                <div className='px-4 bg-white flex-col justify-center items-center rounded h-72'>
                  <div className='border overflow-hidden rounded-lg bg-gray-200'>
                    <div className='px-6 py-4'>
                      <div className='grid lg:grid-cols-3'>
                        <div className='px-4 rounded'>
                          <p className='text-medium font-bold'>Name</p>
                        </div>

                        <div className='px-4 rounded'>
                          <p className='text-medium font-bold'>Email</p>
                        </div>

                        <div className='px-4 rounded'>
                          <p className='text-medium font-bold'>Subscription</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  {load
                    ? customers.map((customer, i) => {
                        return (
                          <>
                            <div className='border overflow-hidden rounded-lg '>
                              <div className='px-6 py-4'>
                                <div className='grid lg:grid-cols-3'>
                                  <div className='px-4  bg-white flex items-center rounded'>
                                    <Link
                                      to={`/customer/detail/${customer.id}`}
                                    >
                                      <p className='font-bold text-left '>
                                        {customer.name}
                                      </p>
                                    </Link>
                                  </div>
                                  <div className='px-4  bg-white flex items-center rounded'>
                                    <p className='font-bold'>
                                      {customer.email}
                                    </p>
                                  </div>
                                  <div className='px-4 bg-white  rounded'>
                                    {customer.subscriptions.length === 0
                                      ? 'Free Customer'
                                      : 'Pro Customer'}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </>
                        );
                      })
                    : null}
                </div>
              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }

  useEffect(() => {
    const load = setTimeout(() => {
      <contentUi />;
      setLoad(true);
    }, 3000);
    return () => clearTimeout(load);
  }, [load]);

  return contentUi;
}
